import { gql } from '@apollo/client';
import { ImageFragment } from './image';

export const ResourceBaseFragment = gql`
  fragment ResourceBaseFragment on Resource {
    createdAt
    publishedAt
    title
    slug
    duration
    resourceType {
      data {
        attributes {
          type
        }
      }
    }
    briefDescription
    themes {
      data {
        attributes {
          theme
          topic {
            data {
              attributes {
                topic
              }
            }
          }
        }
      }
    }
    cover {
      data {
        ...ImageFragment
      }
    }
    DefaultContentTemplate {
      __typename
      ... on ComponentCommonAuthorDetailed {
        authors {
          data {
            attributes {
              name
              role
              bio
              avatar {
                data {
                  ...ImageFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
